import { render, staticRenderFns } from "./fundDatagramDetail.vue?vue&type=template&id=243ed939&scoped=true"
import script from "./fundDatagramDetail.vue?vue&type=script&lang=js"
export * from "./fundDatagramDetail.vue?vue&type=script&lang=js"
import style0 from "./fundDatagramDetail.vue?vue&type=style&index=0&id=243ed939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ed939",
  null
  
)

export default component.exports